const o = {
  id: "ColoradoCash5",
  logo: !0,
  name: "Cash 5",
  style: {
    colorPrimary: "#b3d335"
  }
};
export {
  o as default
};
